import { writable } from "svelte/store";
import type { EnrichedLeadWithMessage, Message } from "$lib/types/campaigns-new";

interface LeadsStore {
  activeLeadId: string;
  selectedLeads: EnrichedLeadWithMessage[];
}

function createLeadsStore() {
  const { subscribe, update, set } = writable<LeadsStore>({
    activeLeadId: "",
    selectedLeads: [],
  });

  return {
    set,
    subscribe,

    updateMessage: (leadId: string, message: Partial<Message>) => {
      update((store) => ({
        ...store,
        selectedLeads: store.selectedLeads.map((lead) =>
          lead.leadId === leadId ? { ...lead, message: { ...lead.message, ...message } } : lead,
        ),
      }));
    },

    approveMessage: (leadId: string) => {
      update((store) => ({
        ...store,
        selectedLeads: store.selectedLeads.map((lead) =>
          lead.leadId === leadId ? { ...lead, message: { ...lead.message, is_approved: true } } : lead,
        ),
      }));
    },

    setAnswers: (leadId: string, answers: { answer: string; isLoading: boolean }[]) => {
      update((store) => ({
        ...store,
        selectedLeads: store.selectedLeads.map((lead) => (lead.leadId === leadId ? { ...lead, answers } : lead)),
      }));
    },
  };
}

export const leadsStore = createLeadsStore();
